import { createStore, combineReducers, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import authReducer from '../reducers/authReducer';
import subMenuReducer from '../reducers/subMenuReducer';
import selectedRowsReducer from '../reducers/selectedRowsReducer';
import dataLoadedReducerCreator from '../reducers/dataLoadedReducerCreator';
import brokerProductsReducer from '../reducers/brokerProductsReducer';
import brokerProductReducer from '../reducers/brokerProductReducer';

const reducers = {
  authReducer,
  selectedRowsReducer,
  salesman: dataLoadedReducerCreator('salesman', '/salesman', 'ROLE_USER'),
  userInfo: dataLoadedReducerCreator('userInfo', '/user_info', 'ROLE_USER'),
  cases: dataLoadedReducerCreator('cases', '/dashboard/cases', 'ROLE_CASES'),
  revenues: dataLoadedReducerCreator('revenues', '/dashboard/revenues', 'ROLE_STATISTICS'),
  referrals: dataLoadedReducerCreator('referrals', '/dashboard/recommendation-links', 'ROLE_USER'),
  agents: dataLoadedReducerCreator('agents', '/agents', 'ROLE_USER'),
  customers: dataLoadedReducerCreator('customers', '/customers', 'ROLE_USER'),
  brokerArticles: dataLoadedReducerCreator(
    'brokerArticles',
    `https://pragmago.pl/wp-json/pragma/v1/banners/spbroker?time=${new Date().getTime()}`,
    'ROLE_BANNERS_BROKER'
  ),
  partnerArticles: dataLoadedReducerCreator(
    'partnerArticles',
    `https://pragmago.pl/wp-json/pragma/v1/banners/sppartner?time=${new Date().getTime()}`,
    'ROLE_BANNERS_PARTNER'
  ),
  products: dataLoadedReducerCreator('products', '/products', 'ROLE_USER'),
  currentSettlement: dataLoadedReducerCreator('currentSettlement', '/settlement/current', 'ROLE_SETTLEMENTS_LIST'),
  subMenuReducer,
  brokerProducts: brokerProductsReducer,
  brokerProduct: brokerProductReducer,
  repaymentPeriods: dataLoadedReducerCreator("repaymentPeriods", "/repayment_periods", "ROLE_USER"),
};

const middlewares = [ReduxThunk];
const reducer = combineReducers(reducers);
const store = createStore(reducer, {}, applyMiddleware(...middlewares));

export default store;
